import Vue from 'vue';
import humps from 'humps';
import request from '../../request';

export default {
  state: {
    users: [],
    adminToken: undefined,
  },
  mutations: {
    setUsers(state, payload) {
      Vue.set(state, 'users', humps.camelizeKeys(payload));
    },
  },
  actions: {
    adminGetUsers(context) {
      request.make({
        type: 'GET',
        url: `${process.env.API_URL}user`,
      }, (err, res) => {
        if (res.status === 200) {
          context.commit('setUsers', res.body.data);
        }
      });
    },
    AdminApproveUser(context, payload) {
      request.make({
        type: 'PATCH',
        url: `${process.env.API_URL}user`,
        data: payload,
      }, () => {
        context.dispatch('adminGetUsers');
      });
    },
    AdminLoginAsUser(context, payload) {
      const data = {
        emailUsername: payload,
      };

      request.make({
        type: 'POST',
        url: `${process.env.API_URL}auth/loginAs`,
        data,
      }, (err, res) => {
        context.dispatch('setUser', res.body.user)
          .then(() => {
            context.dispatch('setJWT', res.body.token)
              .then(() => {
                window.location = '/';
              });
          });
      });
    },
  },
  getters: {
  },
};



// WEBPACK FOOTER //
// ./src/store/admin/users.js